// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1GVTP","list":"styles_list__3o9HO"};